<template>
  <div>
    <div
      :data-version="$store.getters.appVersion"
      class="container"
      :class="{ 'login-new': isLoginOrHomePage }"
    >
      <alert-container />
      <mbe-topbar v-if="!isLoginPage" :showBreadcrumb="false" />

      <div :class="{ row: true, 'breadcrumb-shown': showBreadcrumb() }">
        <!--<div class="col-1 p-0 divnavbar" v-if="!isLoginPage &&  !isHomePage">
                    <mbe-navbar></mbe-navbar>
				</div>-->
        <!-- Div router-view -->
        <div
          class="col-12 divrouter"
          :class="{ 'col-12 no-padding': isLoginOrHomePage }"
        >
          <slot></slot>
        </div>
        <!-- Div space -->
        <div class="invisible col-1 d-none d-xl-block" />
      </div>
    </div>
    <vue-snotify />
    <loading
      :event-bus="myEventBus"
      event-show="show-my-full-loading"
      event-hide="hide-my-full-loading"
      :label="$t('loading')"
    />
    <div id="modal_container" />
  </div>
</template>

<script>
import Vue from "vue";
import Topbar from "@components/controls/Topbar.vue";
import Navbar from "@components/controls/Navbar.vue";
import { Component } from "vue-property-decorator";
import { AuthService } from "@/services/AuthService";
import { VersionCheckService } from "@/services/VersionCheckService";
import { EventBus } from "@/event-bus";
import loading from "vue-full-loading";

@Component({
  components: {
    MbeTopbar: Topbar,
    MbeNavbar: Navbar,
    loading
  },
  $bus: {}
})
export default class Default extends Vue {
  auth = AuthService;
  checkVersionService = VersionCheckService;

  myEventBus = EventBus;

  constructor() {
    super();
    this.auth = new AuthService();
    this.checkVersionService = new VersionCheckService();
    EventBus.$on("to-modal", function(content) {
      // TODO: EventBus event is called 4 or 5 times (also in event-bus.ts)
      // this code allows no errors by checking if modal_container exists
      // even when receiving this event several times
      const div = document.getElementById("modal_container");
      if (div !== null) {
        content.$mount("#modal_container");
      }
    });
    EventBus.$on("out-of-modal", function(content) {
      const Empty = Vue.extend({
        template: '<div id="modal_container"></div>'
      });
      const empty = new Empty();
      empty.$mount(".mbe-modal-mask");
    });
  }

  /**
   * Registers interceptor for authentication
   */
  created() {
    const titlePrefix = this.$store.getters.envs.envLabel
      ? this.$store.getters.envs.envLabel + " "
      : "";
    document.title = titlePrefix + "MBE OnLine";
  }

  // Hide topbar and navbar
  get isLoginPage() {
    return this.$route.path === "/login";
  }

  get isHomePage() {
    return this.$route.name === "ShipmentsMenuNew";
  }

  get isLoginOrHomePage() {
    return (
      this.$route.path === "/login" || this.$route.name === "ShipmentsMenuNew"
    );
  }

  showBreadcrumb() {
    if (
      this.$route.path !== "/login" &&
      this.$route.name !== "Dashboard" &&
      this.$route.name !== "ShipmentsMenuNew" &&
      this.$route.name !== "Pickups" &&
      this.$route.name !== "TradetermsFuel"
    ) {
      return true;
    } else {
      return false;
    }
  }
}
</script>

<style lang="scss">
@import "../index";

.container {
  margin-right: 0px !important;
  margin-left: 0px !important;
  max-width: none !important;
  display: flex;
  justify-content: center;
}

.container > .row {
  width: 100%;
}

.container > .row > .divrouter {
  padding-top: 75px;
  padding-bottom: 40px;
}

.container.login > .row > .divrouter {
  padding-top: 0px;
}

.container.login-new {
  padding: 0;
  margin: 0;
}

.container > .row.breadcrumb-shown > .login-new {
  padding: 0;
  width: 100%;
}

.container > .row.breadcrumb-shown > .divrouter {
  padding-top: 175px;
}

.container > .row.breadcrumb-shown > .divrouter .maindiv {
  margin-top: -86px;
  width: 100%;
  padding-right: 125px;
}

.divnavbar {
  z-index: 10;
}

.maindiv {
  position: fixed;
  margin-top: 89px;
  z-index: 1;
}
</style>
